import { generateUuid } from '../../../helpers/string';
import { MOCK_IMAGE_7 } from '../../../mock/mock-data';
import {
    PaginationMetaResource,
    StrapiDateData,
    StrapiEntity,
    StrapiEntityData,
    StrapiMeta,
} from '../../@api/Strapi';
import { Block, BlockResource } from '../../Block/Block';
import { Image, MediaResource } from '../../Media/Media';
import { Seo, SeoResource } from '../../Seo/Seo';
import { ProductListCallToActionInterface, ProductListCallToActionResource } from '../ProductListCallToAction/ProductListCallToAction';

export interface ProductCategoryResource extends StrapiEntityData, StrapiDateData {
    title: string;
    slug: string;
    description: string;
    sylius_id: number;
    image?: MediaResource;
    lineImage?: MediaResource;
    callToAction?: ProductListCallToActionResource[];
    elements: BlockResource[];
    elementsBottom: BlockResource[];
    seo?: SeoResource;
}

export type ProductCategoryResponse = StrapiEntity<ProductCategoryResource[]> & StrapiMeta<PaginationMetaResource>;

export enum ProductCategoryImageType {
    lineImage = 'lineImage',
    defaultImage = 'defaultImage',
}

export interface ProductCategoryBase {
    id: string;
    slug: string;
}

export interface ProductCategory extends ProductCategoryBase {
    name: string;
    children?: ProductCategory[];
    image?: Image;
    imageType?: ProductCategoryImageType;
}

export interface ProductCategoryPageData {
    id: string;
    slug: string;
    title: string;
    image: Image;
    meilisearchProductListName: string;
    callToActions: ProductListCallToActionInterface[];
    blocksBelowHeader: Block[];
    blocksBelowProductList: Block[];
    seo?: Seo;
}

enum ProductCategoryHierarchy {
    slug = 'slug',
    subCategory = 'subCategory',
    subSubCategory = 'subSubCategory',
}

export type ProductCategoryParams = Record<ProductCategoryHierarchy, string | undefined>;

export const defaultCategoryPageData = (): ProductCategoryPageData => ({
    id: generateUuid(),
    slug: '',
    title: '',
    meilisearchProductListName: '',
    image: MOCK_IMAGE_7, // TODO: Use different image
    callToActions: [],
    blocksBelowHeader: [],
    blocksBelowProductList: [],
});
